const UxPage = () => {
  return (
    <div>
      <table style={{ border: '1px solid black' }} border={'1'} cellPadding="1" cellSpacing="1">
        <tbody>
          <tr>
            <th>Name</th>
            <th>Example</th>
            <th>Code</th>
          </tr>
          <tr>
            <td>Primary Button</td>
            <td>
              <button variant={'contained'} className={'btn btn-prev btn-primary btn-lg pull-left action-primary'}>
                Primary
              </button>
            </td>
            <td>
              <textarea
                value={` <button variant={'contained'} className={'btn btn-prev btn-primary btn-lg pull-left action-primary'}>
                Primary
              </button>`}
              ></textarea>
            </td>
          </tr>

          <tr>
            <td>Secondary Button</td>
            <td>
              <button variant={'contained'} className={'btn btn-prev btn-primary btn-lg pull-left action-secondary'}>
                Secondary
              </button>
            </td>
            <td>
              <textarea
                value={`         <button variant={'contained'} className={'btn btn-prev btn-primary btn-lg pull-left action-secondary'}>
                Secondary
              </button>`}
              ></textarea>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default UxPage;
